'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.monthsSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/monthsSince.js
// module id = 579
// module chunks = 0